module.exports = __webpack_public_path__ + "img/iPhone.dc907acf.png";